import { isDefined } from "@clipboard-health/util-ts";
import { logError } from "@src/appV2/lib/analytics";
import { getPreference } from "@src/appV2/NativeAdapters/preferences.adapter";
import { useQuery } from "@tanstack/react-query";

export function useGetPreference(key: string) {
  return useQuery({
    queryKey: [`preference-${key}`],
    queryFn: async () => {
      try {
        const value = await getPreference(key);
        // We cannot return undefined
        // https://github.com/TanStack/query/discussions/4457
        return value;
      } catch (error) {
        logError("Error getting preference", {
          error,
          metadata: { key },
        });
        throw error;
      }
    },
    enabled: isDefined(key),
  });
}
